import API, { config } from '../API';

export const get = (token) => {
  const apiConf = config;
  apiConf.headers.Authorization = `Bearer ${token}`;
  return API.get('/subcategory', apiConf);
};

export const post = (payload) => API.post('/subcategory', payload);
